module.exports = __webpack_public_path__ + "static/img/no-data.223100b9.png";